export default "__VITE_ASSET__Cht746jV__"